import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-primary-create-submission-button',
  templateUrl: './primary-create-submission-button.component.html',
  styleUrls: ['./primary-create-submission-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrimaryCreateSubmissionButtonComponent {
  @Output() buttonClicked = new EventEmitter<void>();
}
